/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BankViewerItemDto } from "./BankViewerItemDto";
export type BankViewerTemplateSummaryDto = {
  /**
   * 문제틀 key — 예: S-E14-E001a
   */
  key: string;
  /**
   * 묻는 모양 — 예: 식의 꼴 고르기
   */
  solveLabel: string;
  /**
   * 게시·보류·폐기
   */
  status: BankViewerTemplateSummaryDto.status;
  itemCount: number;
  /**
   * 대표 문항 — 가장 작은 seed(새 엔진 버전부터), 문항이 없으면 null
   */
  sample: BankViewerItemDto | null;
};
export namespace BankViewerTemplateSummaryDto {
  /**
   * 게시·보류·폐기
   */
  export enum status {
    PUBLISHED = "published",
    GATED = "gated",
    RETIRED = "retired",
  }
}
